var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.001 67.366H0V9.103A8.829 8.829 0 0 1 8.828.275h494.345a8.829 8.829 0 0 1 8.828 8.828v58.263zM0 134.455h512v67.09H0z",
    fill: "#73AF00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M0 67.366h512v67.09H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.172 335.724H8.828A8.829 8.829 0 0 1 0 326.896v-58.262h512v58.262a8.828 8.828 0 0 1-8.828 8.828z",
    fill: "#73AF00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M0 201.545h512v67.09H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.207 201.545H8.828A8.829 8.829 0 0 1 0 192.717V9.103A8.829 8.829 0 0 1 8.828.275h185.379a8.829 8.829 0 0 1 8.828 8.828v183.614a8.83 8.83 0 0 1-8.828 8.828z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.335 47.637L86.577 85.889l-40.322.312c-2.21.018-3.127 2.838-1.348 4.151l32.438 23.954-12.163 38.446c-.666 2.108 1.734 3.851 3.531 2.566l32.806-23.448 32.806 23.448c1.799 1.286 4.199-.458 3.531-2.566l-12.163-38.445 32.438-23.954c1.779-1.313.862-4.135-1.348-4.151l-40.322-.312L103.7 47.638c-.7-2.099-3.666-2.099-4.365-.001z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.23a4a972f00b60e1b47b5c041efca482.svg";
export { ForwardRef as ReactComponent };